(function () {
  'use strict';

  var DESKTOP_MQ = '(min-width: 1150px)';
  var JITTER = 5;

  function initHeaderScroll(root) {
    var el = (root || document).querySelector('hdt-sticky-header[data-custom-hide-on-scroll]');
    if (!el || el.dataset.customHideBound === '1') return;

    var wrapper = el.closest('.hdt-section-header');
    if (!wrapper) return;

    el.dataset.customHideBound = '1';

    var devices = el.getAttribute('data-custom-hide-devices') || 'both';
    var threshold = parseInt(el.getAttribute('data-custom-hide-threshold'), 10);
    if (isNaN(threshold)) threshold = 150;
    var speed = parseInt(el.getAttribute('data-custom-hide-speed'), 10);
    if (isNaN(speed)) speed = 300;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var speedMs = (reduceMotion ? 0 : speed) + 'ms';
    wrapper.style.setProperty('--custom_header-hide-speed', speedMs);
    /* Also on <html> so elements outside the header — the sticky PLP control bar —
       can sync their own transition to this same duration. */
    document.documentElement.style.setProperty('--custom_header-hide-speed', speedMs);
    wrapper.classList.add('custom_header--hide-ready');

    var mql = window.matchMedia(DESKTOP_MQ);

    function deviceMatches() {
      if (devices === 'both') return true;
      return devices === 'desktop' ? mql.matches : !mql.matches;
    }

    function isScrollLocked() {
      var de = document.documentElement;
      return de.classList.contains('no-scroll') || de.hasAttribute('scroll-lock');
    }

    function currentY() {
      return window.scrollY || window.pageYOffset || 0;
    }

    function show() { wrapper.classList.remove('custom_header--hidden'); }
    function hide() { wrapper.classList.add('custom_header--hidden'); }

    var enabled = deviceMatches();
    var lastY = currentY();
    var ticking = false;

    function update() {
      ticking = false;
      if (!enabled) { show(); return; }

      var y = currentY();
      if (isScrollLocked()) { show(); lastY = y; return; }

      var delta = y - lastY;
      if (Math.abs(delta) < JITTER) return;

      if (y <= threshold) {
        show();
      } else if (delta > 0) {
        hide();
      } else {
        show();
      }
      lastY = y;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    function onDeviceChange() {
      enabled = deviceMatches();
      lastY = currentY();
      if (!enabled) show();
    }
    if (mql.addEventListener) mql.addEventListener('change', onDeviceChange);
    else if (mql.addListener) mql.addListener(onDeviceChange);

    var lockObserver = new MutationObserver(function () {
      if (isScrollLocked()) show();
    });
    lockObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'scroll-lock']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeaderScroll(); });
  } else {
    initHeaderScroll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initHeaderScroll(e.target);
  });
})();
